import { create } from 'zustand';

type CampaignStore = {
  campaignListPage: number;
  setCampainListPage: (page: number) => void;
  campainListlimit: number;
  setCampainListLimit: (listlimit: number) => void;
  isOpenCampaignModal: boolean;
  openCampaignModal: () => void;
  isOpenCampaignDetailModal: boolean;
  openCampaignDetailModal: () => void;
};

export const useCampaignStore = create<CampaignStore>()((set) => ({
  campainListlimit: 10,
  campaignListPage: 1,
  setCampainListPage: (campaignListPage) => set({ campaignListPage }),
  setCampainListLimit: (campainListlimit) => set({ campainListlimit }),
  isOpenCampaignModal: false,
  openCampaignModal: () =>
    set((state) => ({ isOpenCampaignModal: !state.isOpenCampaignModal })),
  isOpenCampaignDetailModal: false,
  openCampaignDetailModal: () =>
    set((state) => ({
      isOpenCampaignDetailModal: !state.isOpenCampaignDetailModal,
    })),
}));
